var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.05916V16.9492C22 17.9192 21.21 18.8092 20.24 18.9292L19.93 18.9692C18.29 19.1892 15.98 19.8692 14.12 20.6492C13.47 20.9192 12.75 20.4292 12.75 19.7192V5.80916C12.75 5.43916 12.96 5.09916 13.29 4.91916C15.12 3.92916 17.89 3.04916 19.77 2.88916H19.83C21.03 2.88916 22 3.85916 22 5.05916Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.71 4.91916C8.87999 3.92916 6.10999 3.04916 4.22999 2.88916H4.15999C2.95999 2.88916 1.98999 3.85916 1.98999 5.05916V16.9492C1.98999 17.9192 2.77999 18.8092 3.74999 18.9292L4.05999 18.9692C5.69999 19.1892 8.00999 19.8692 9.86999 20.6492C10.52 20.9192 11.24 20.4292 11.24 19.7192V5.80916C11.24 5.42916 11.04 5.09916 10.71 4.91916ZM4.99999 7.94916H7.24999C7.65999 7.94916 7.99999 8.28916 7.99999 8.69916C7.99999 9.11916 7.65999 9.44916 7.24999 9.44916H4.99999C4.58999 9.44916 4.24999 9.11916 4.24999 8.69916C4.24999 8.28916 4.58999 7.94916 4.99999 7.94916ZM7.99999 12.4492H4.99999C4.58999 12.4492 4.24999 12.1192 4.24999 11.6992C4.24999 11.2892 4.58999 10.9492 4.99999 10.9492H7.99999C8.40999 10.9492 8.74999 11.2892 8.74999 11.6992C8.74999 12.1192 8.40999 12.4492 7.99999 12.4492Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon_book.1cde0bd1c34eaaa5d504f7b7cb565046.svg";
export { ForwardRef as ReactComponent };